import FindInPageOutlinedIcon from "@material-ui/icons/FindInPageOutlined";
import { ReportsArchive } from "./ReportsArchive";

export default {
  icon: FindInPageOutlinedIcon,
  list: ReportsArchive,
};
